export default (products) => {
  if (!products) return [];
  return products.map((p, i, a) => {
    if (a[i - 1] && p.category !== a[i - 1].category) {
      return { ...p, hasDivider: true };
    }
    return p;
  });
};
